module.exports = __webpack_public_path__ + "img/5.4f3a2f3e.svg";